import Collection from './generic/collection'
import { onAjaxContentLoaded } from './generic/evented'
import { getCfg } from './utils/getCfg'
import { getFormDataFromObj } from './utils/getFormDataFromObj'
import Preloader from './preloader'
import { makeRequest } from './utils/makeRequest'
import FormSend from './forms/formSend'

const instance = '[data-js-product-status]'

class ProductStatus {

  els = {
    instance,
    control: '[data-js-product-status-control]',
    orderSumContainer: '[data-js-product-status-order-sum-container]'
  }

  defaultCfg = {
    method: 'POST',
    url: 'json/changeProductStatusExample.json',
    successMsg: 'Успешное изменение статуса заказа',
    errorMsg: 'Произошла ошибка при изменении статуса заказа',
    auxParams: {},
  }

  constructor (instance) {
    this.instance = instance
    this.orderSumContainer = document.querySelector(this.els.orderSumContainer)
    this.cfg = getCfg(this.instance, this.els.instance, this.defaultCfg)
    this.bindEvents()
  }

  resetControl (control) {
    if (control.nodeName === 'SELECT') {
      const { options } = control
      for (const option of options) {
        if (option.defaultSelected) {
          control.value = option.value
          break
        }
      }
    }
  }

  afterSuccess(resp) {
    const modalSrc = resp?.modal ?? '#modal-success'
    $.fancybox.close()
    $.fancybox.open({
      src: $(modalSrc),
      type: 'inline',
      opts: {
        afterClose: function (instance, current) {
          if (current.src[0].dataset.hasOwnProperty('jsReloadPage')) {
            window.location.reload()
          }
        }
      }
    })

    if (resp.replaceElements) {
      FormSend.replaceNodes(resp.replaceElements)
    }
  }

  processRequest (controlData, control = null) {
    const fd = getFormDataFromObj({ ...this.cfg.auxParams, ...controlData })
    this.request(this.cfg, fd).then((resp) => {
      if (resp && resp.success) {
        this.afterSuccess(resp)
      } else {
        const modalSrc = resp?.modal ?? '#modal-error'
        $.fancybox.close()
        $.fancybox.open({
          src: $(modalSrc),
          type: 'ajax'
        })
        if (control) {
          this.resetControl(control)
        }
      }
    })
  }

  async request (cfg, data) {
    Preloader.display()
    console.debug(cfg, data)
    return await makeRequest({ ...cfg, data }).then((resp) => {return resp}).catch(() => {
      return false
    })
      .finally(() => {
        Preloader.hide()
      })
  }

  getControlData (control) {
    const data = getCfg(control, this.els.control)
    data[control.name] = control.value
    return data
  }

  handleControlChange (e) {
    const { target } = e
    if (target.matches(this.els.control)) {
      const controlData = this.getControlData(target)
      this.processRequest(controlData, target)
    }
  }

  bindEvents () {
    this.instance.addEventListener('change', (e) => {this.handleControlChange(e)})
  }
}

export class ProductStatusCollection extends Collection {
  constructor () {
    super(instance, ProductStatus)
    this.init()
  }

  init (context = document) {
    context.querySelectorAll(instance).forEach(el => {
      this.collection = new ProductStatus(el)
    })
  }

  bindEvents () {
    onAjaxContentLoaded(() => {
      this.init()
    })
  }
}
